/** Max characters shown for receipt filenames in vehicle repair tables (full name via `title`). */
export const RECEIPT_FILENAME_DISPLAY_MAX = 6;

export function truncateReceiptFileLabel(name, maxChars = RECEIPT_FILENAME_DISPLAY_MAX) {
  const s = String(name ?? "").trim();
  if (!s.length) return "";
  if (s.length <= maxChars) return s;
  return `${s.slice(0, maxChars)}…`;
}
